import React from 'react';
import { Modal, Form, Input, Button, Spin, Select } from 'antd';

const { Option } = Select;

const AddUserForm = ({ visible, onCancel, onAddUser, loading, dealers }) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      onAddUser(values);
    }).catch((info) => {
      console.log('Validate Failed:', info);
    });
  };

  return (
    <Modal
      visible={visible}
      title="新增用戶"
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} loading={loading}>
          Send
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" autoComplete="off">
          <Form.Item
            name="email"
            label="E-mail"
            rules={[
              { required: true, message: 'Please input the email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input autoComplete="off" disabled={loading} />
          </Form.Item>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please input the name!' }]}
          >
            <Input disabled={loading} />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please input the password!' }]}
          >
            <Input.Password autoComplete="new-password" disabled={loading} />
          </Form.Item>
          <Form.Item
            name="dealer_id"
            label="Dealer"
            rules={[{ required: true, message: 'Please select a dealer!' }]}
          >
            <Select placeholder="Select a dealer" disabled={loading}>
              {(dealers || []).map((dealer) => (
                <Option key={dealer.id} value={dealer.id}>
                  {dealer.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="download_limit"
            label="Download Limit"
          >
            <Input placeholder="Enter download limit" min={0} step={0.01} stringMode />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default AddUserForm;